export default __webpack_public_path__ + "static/media/hang6.c5534102.png";